import { useMutation } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { isValidUUID } from '../../../utils/functions';

interface IDeleteTitle {
  titleId: string;
}

const DeleteTitle = async (params: IDeleteTitle) => {
  if (isValidUUID(params?.titleId)) {
    const url = `candidate-area/titles/delete/${params?.titleId}/`;

    const response = await configApi.delete(url);

    return response.data;
  }
};
export const useDeleteTitle = () => {
  return useMutation({
    mutationKey: ['delete_title'],
    mutationFn: (data: IDeleteTitle) => DeleteTitle(data),
  });
};
